import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { doc, getDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "../firebaseConfig";
import {
  dashboardMenu,
  applicationsMenu,
  pagesMenu,
  uiElementsMenu,
} from "../data/Menu";

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
      profilePicture: null,
      role: "",
      isAdmin: false,
      permissions: {},
      userId: "",  // add userId to state
    };
  }

  fetchUserData = async (user) => {
    try {
      const userDocRef = doc(db, "Users", user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        const userRole = userData.role || "default";

        this.setState({
          username: userData.fullName || "Unknown User",
          email: userData.email || "No email",
          profilePicture: userData.profilePicture || null,
          role: userRole,
          isAdmin: userRole === "admin",
          userId: user.uid,  // store user uid in state
        });


        if (userRole === "admin") {
          this.setState({
            permissions: {
              canAccessPayrolls: true,
              canApproveDenyLeaves: true,
              canClockInOut: true,
              canManageLeaves: true,
              canManagePayrolls: true,
              canUploadDocuments: true,
              canViewClockInOut: true,
              canViewInvoice: true,
              canViewYearlyDocuments: true,
            },
          });
        } else {
          const roleDocRef = doc(db, "Roles", userRole);
          const roleDoc = await getDoc(roleDocRef);

          if (roleDoc.exists()) {
            this.setState({
              permissions: roleDoc.data().permissions || {},
            });
          } else {
            console.warn(`No role document found for role: ${userRole}`);
          }
        }
      } else {
        console.warn("User document does not exist in Firestore");
      }
    } catch (error) {
      console.error("Error fetching user data or permissions:", error);
    }
  };

  componentDidMount() {
    const savedSkin = localStorage.getItem("sidebar-skin") || "dark";
    this.setSidebarSkin(savedSkin);

    const auth = getAuth();

    this.authUnsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        this.fetchUserData(user);
      } else {
        console.warn("No user is signed in.");
        this.setState({
          username: "",
          email: "",
          profilePicture: null,
          role: "",
          isAdmin: false,
          permissions: {},
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.authUnsubscribe) {
      this.authUnsubscribe();
    }
  }

  setSidebarSkin = (skin) => {
    const HTMLTag = document.querySelector("html");
    HTMLTag.setAttribute("data-sidebar", skin);
    localStorage.setItem("sidebar-skin", skin);
  };

  toggleFooterMenu = (e) => {
    e.preventDefault();
    const parent = e.target.closest(".sidebar");
    parent.classList.toggle("footer-menu-show");
  };

  render() {
    const { username, email, profilePicture, isAdmin, permissions, userId, role } = this.state;

    return (
      <div className="sidebar">
                       {/* Enhanced Sidebar Header */}
               <div className="sidebar-header">
                 <Link to="/" className="sidebar-logo" style={{
                   display: 'flex',
                   alignItems: 'center',
                   textDecoration: 'none',
                   color: 'inherit'
                 }}>
                   <div className="sidebar-logo-icon" style={{
                     width: '32px',
                     height: '32px',
                     background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                     borderRadius: '10px',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     marginRight: '12px',
                     boxShadow: '0 4px 16px rgba(79, 70, 229, 0.4)'
                   }}>
                     <i className="ri-building-2-line" style={{ color: '#fff', fontSize: '18px' }}></i>
                   </div>
                   <div>
                     <div style={{ fontWeight: '700', fontSize: '18px', lineHeight: '1.2', color: '#f8fafc' }}>EZARLY</div>
                     <div style={{ fontSize: '10px', opacity: '0.6', fontWeight: '500', color: '#cbd5e1' }}>HR Management</div>
                   </div>
                 </Link>
               </div>

                {/* Enhanced User Profile Section */}
        <div className="sidebar-profile" style={{
          padding: '20px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.08) 0%, rgba(124, 58, 237, 0.08) 100%)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '14px',
              background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px',
              boxShadow: '0 4px 16px rgba(79, 70, 229, 0.4)'
            }}>
              {profilePicture ? (
                <img
                  src={`data:image/jpeg;base64,${profilePicture}`}
                  alt="Profile"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '14px'
                  }}
                />
              ) : (
                <i className="ri-user-line" style={{ color: '#fff', fontSize: '20px' }}></i>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{
                fontWeight: '600',
                fontSize: '14px',
                marginBottom: '2px',
                color: '#f8fafc'
              }}>
                {username || 'User'}
              </div>
              <div style={{
                fontSize: '11px',
                opacity: '0.7',
                color: '#cbd5e1'
              }}>
                {role || 'Employee'}
              </div>
            </div>
          </div>
          <div style={{
            background: 'rgba(79, 70, 229, 0.1)',
            borderRadius: '10px',
            padding: '8px 12px',
            fontSize: '11px',
            color: '#cbd5e1',
            opacity: '0.9'
          }}>
            <i className="ri-mail-line" style={{ marginRight: '6px' }}></i>
            {email || 'user@company.com'}
          </div>
        </div>

        <PerfectScrollbar
          className="sidebar-body"
          ref={(ref) => (this._scrollBarRef = ref)}
        >
          <SidebarMenu
            isAdmin={isAdmin}
            permissions={permissions}
            dashboardMenu={dashboardMenu}
            onUpdateSize={() => this._scrollBarRef?.updateScroll()}
          />
        </PerfectScrollbar>

        
      </div>
    );
  }
}

class SidebarMenu extends Component {
  filterMenuByPermissions = (menu) => {
    const { permissions, isAdmin } = this.props;

    return menu.filter((item) => {
      if (isAdmin) {
        return true;
      }

      const permissionMap = {
        Payroll: "canAccessPayrolls",
        "Approve Leaves": "canApproveDenyLeaves",
        "Clock In & Out": "canClockInOut",
        "Manage Leaves": "canManageLeaves",
        "Manage Payrolls": "canManagePayrolls",
        "File Manager": "canUploadDocuments",
        "User Clocks": "canViewClockInOut",
        Invoice: "canViewInvoice",
        "Yearly Document": "canViewYearlyDocuments",
        "Create Invoice": "canCreateInvoices",
        Maintaince: "admin",
        Roles: "admin",
        "Create Users": "admin",
        "Signed Documents": "canUploadDocuments",
      };

      const requiredPermission = permissionMap[item.label];
      return requiredPermission ? permissions[requiredPermission] || false : true;
    });
  };

  populateMenu = (menu) => {
    const filteredMenu = this.filterMenuByPermissions(menu);

    return (
      <ul className="nav nav-sidebar">
        {filteredMenu.map((item, key) => (
          <li key={key} className="nav-item">
            {!item.submenu ? (
              <NavLink 
                  to={item.link} 
                  className="nav-link"
                                           style={({ isActive }) => ({
                           display: 'flex',
                           alignItems: 'center',
                           padding: '12px 20px',
                           borderRadius: '12px',
                           margin: '4px 16px',
                           transition: 'all 0.3s ease',
                           textDecoration: 'none',
                           color: isActive ? '#f8fafc' : 'rgba(248, 250, 252, 0.7)',
                           background: isActive ? 'rgba(79, 70, 229, 0.15)' : 'transparent',
                           borderLeft: isActive ? '3px solid #4f46e5' : '3px solid transparent',
                           fontWeight: isActive ? '600' : '500'
                         })}
                                           onMouseEnter={(e) => {
                           if (!e.target.classList.contains('active')) {
                             e.target.style.background = 'rgba(79, 70, 229, 0.1)';
                             e.target.style.transform = 'translateX(4px)';
                             e.target.style.boxShadow = '0 4px 12px rgba(79, 70, 229, 0.15)';
                             e.target.style.color = '#f8fafc';
                           }
                         }}
                         onMouseLeave={(e) => {
                           if (!e.target.classList.contains('active')) {
                             e.target.style.background = 'transparent';
                             e.target.style.transform = 'translateX(0)';
                             e.target.style.boxShadow = 'none';
                             e.target.style.color = 'rgba(248, 250, 252, 0.7)';
                           }
                         }}
                >
                  <div style={{
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '12px',
                    borderRadius: '6px',
                    background: 'rgba(79, 70, 229, 0.1)'
                  }}>
                    <i className={item.icon} style={{ fontSize: '14px', color: '#4f46e5' }}></i>
                  </div>
                  <span>{item.label}</span>
                </NavLink>
            ) : (
              <div 
                onClick={this.toggleSubMenu} 
                className="nav-link has-sub"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 20px',
                  borderRadius: '12px',
                  margin: '4px 16px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  color: 'inherit'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(102, 126, 234, 0.1)';
                  e.target.style.transform = 'translateX(4px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.transform = 'translateX(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px',
                  borderRadius: '6px',
                  background: 'rgba(102, 126, 234, 0.1)'
                }}>
                  <i className={item.icon} style={{ fontSize: '14px' }}></i>
                </div>
                <span style={{ fontWeight: '500' }}>{item.label}</span>
                <i className="ri-arrow-down-s-line" style={{ 
                  marginLeft: 'auto', 
                  fontSize: '14px',
                  transition: 'transform 0.3s ease'
                }}></i>
              </div>
            )}
            {item.submenu && (
              <nav className="nav nav-sub" style={{ 
                paddingLeft: '20px',
                background: 'rgba(102, 126, 234, 0.05)',
                borderRadius: '8px',
                margin: '0 16px 8px 16px'
              }}>
                {item.submenu.map((subItem, subKey) => (
                  <NavLink
                    to={subItem.link}
                    className="nav-sub-link"
                    key={subKey}
                    style={({ isActive }) => ({
                      display: 'block',
                      padding: '8px 16px',
                      borderRadius: '8px',
                      margin: '2px 8px',
                      transition: 'all 0.3s ease',
                      textDecoration: 'none',
                      color: 'inherit',
                      fontSize: '13px',
                      background: isActive ? 'rgba(102, 126, 234, 0.15)' : 'transparent',
                      fontWeight: isActive ? '600' : '400'
                    })}
                    onMouseEnter={(e) => {
                      if (!e.target.classList.contains('active')) {
                        e.target.style.background = 'rgba(102, 126, 234, 0.1)';
                        e.target.style.transform = 'translateX(4px)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!e.target.classList.contains('active')) {
                        e.target.style.background = 'transparent';
                        e.target.style.transform = 'translateX(0)';
                      }
                    }}
                  >
                    {subItem.label}
                  </NavLink>
                ))}
              </nav>
            )}
          </li>
        ))}
      </ul>
    );
  };

  toggleSubMenu = (e) => {
    e.preventDefault();
    const parent = e.target.closest(".nav-item");
    parent.classList.toggle("show");
    this.props.onUpdateSize();
  };

  toggleMenu = (e) => {
    e.preventDefault();
    const parent = e.target.closest(".nav-group");
    parent.classList.toggle("show");
    this.props.onUpdateSize();
  };

  render() {
    return (
      <React.Fragment>
        <div className="nav-group show">
          <div 
            className="nav-label" 
            onClick={this.toggleMenu}
                               style={{
                     display: 'flex',
                     alignItems: 'center',
                     padding: '16px 20px 8px 20px',
                     fontSize: '12px',
                     fontFamily: 'inherit',
                     textTransform: 'uppercase',
                     color: 'rgba(203, 213, 225, 0.6)',
                     letterSpacing: '1px',
                     position: 'relative',
                     cursor: 'pointer',
                     fontWeight: '600',
                     background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.08) 0%, rgba(124, 58, 237, 0.08) 100%)',
                     borderRadius: '8px',
                     margin: '8px 16px',
                     transition: 'all 0.3s ease'
                   }}
                               onMouseEnter={(e) => {
                     e.target.style.background = 'linear-gradient(135deg, rgba(79, 70, 229, 0.12) 0%, rgba(124, 58, 237, 0.12) 100%)';
                     e.target.style.color = 'rgba(203, 213, 225, 0.8)';
                   }}
                   onMouseLeave={(e) => {
                     e.target.style.background = 'linear-gradient(135deg, rgba(79, 70, 229, 0.08) 0%, rgba(124, 58, 237, 0.08) 100%)';
                     e.target.style.color = 'rgba(203, 213, 225, 0.6)';
                   }}
          >
            <i className="ri-dashboard-3-line" style={{ 
              marginRight: '8px', 
              fontSize: '14px',
              color: '#4f46e5'
            }}></i>
            Dashboard
            <i className="ri-arrow-down-s-line" style={{ 
              marginLeft: 'auto', 
              fontSize: '12px',
              transition: 'transform 0.3s ease'
            }}></i>
          </div>
          {this.populateMenu(dashboardMenu)}
        </div>
      </React.Fragment>
    );
  }
}
